import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Procedure Type List with Query (for remote operations)
export const getProcedureTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_PROCEDURE_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Procedure Type List with Query
export const getProcedureTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_PROCEDURE_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Procedure Type
export const getProcedureType = procedure_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_PROCEDURE_TYPE}${procedure_type_id}`
	);
};

// Add New Procedure Type
export const addNewProcedureTypeApi = procedure_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_PROCEDURE_TYPE}`,
		procedure_type
	);
};

// Update Procedure Type
export const updateProcedureTypeApi = procedure_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_PROCEDURE_TYPE}${procedure_type._id}`,
		procedure_type
	);
};

// Delete Procedure Type
export const deleteProcedureTypeApi = procedure_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_PROCEDURE_TYPE}${procedure_type_id}`
	);
};

// Check if Procedure Type Exists
export const checkProcedureTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_PROCEDURE_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
